module.exports = __webpack_public_path__ + "static/media/check.5d38b0a5.svg";